/* =======================================================================
   Guffee — Shopify AJAX cart drawer
   Framework-free. Talks to the standard Shopify cart routes and renders a
   slide-in drawer. Buttons opt in with data-attributes:
     [data-cart-open]      -> open the drawer
     [data-cart-close]     -> close it
     [data-add][data-variant-id] -> add that variant, then open
     [data-cart-checkout]  -> go to checkout
   ======================================================================= */
(function () {
  "use strict";
  var R = window.GUFFEE_ROUTES || { cart_add: "/cart/add.js", cart_change: "/cart/change.js", cart: "/cart" };

  function money(cents) {
    // Minimal formatter; Shopify money strings are re-fetched for the total.
    return "$" + (cents / 100).toFixed(2);
  }

  function open() { document.body.classList.add("gu-cart-open"); }
  function close() { document.body.classList.remove("gu-cart-open"); }

  function setCount(n) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute("hidden"); else el.setAttribute("hidden", "");
    });
  }

  function lineHTML(item) {
    var img = item.image
      ? '<div class="gu-line-img"><img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, "_80x80$1$2") + '" alt=""></div>'
      : '<div class="gu-line-img">' + (item.product_title ? item.product_title.charAt(0) : "•") + "</div>";
    var variant = (item.variant_title && item.variant_title !== "Default Title") ? '<div class="gu-line-price">' + item.variant_title + "</div>" : "";
    return (
      '<div class="gu-line" data-key="' + item.key + '">' +
        img +
        '<div class="gu-line-main">' +
          '<div class="gu-line-name">' + item.product_title + "</div>" +
          variant +
          '<div class="gu-line-price">' + money(item.final_price) + " each</div>" +
          '<div class="gu-qtyrow">' +
            '<button type="button" data-dec aria-label="Decrease">&minus;</button>' +
            "<span>" + item.quantity + "</span>" +
            '<button type="button" data-inc aria-label="Increase">+</button>' +
          "</div>" +
        "</div>" +
        '<button type="button" class="gu-line-rm" data-rm>Remove</button>' +
      "</div>"
    );
  }

  function render(cart) {
    var body = document.querySelector("[data-cart-body]");
    if (body) {
      if (!cart.items.length) {
        body.innerHTML = '<div class="gu-cart-empty"><b>Your cart is empty</b><div>Add a pouch to get started.</div></div>';
      } else {
        body.innerHTML = cart.items.map(lineHTML).join("");
      }
    }
    var total = document.querySelector("[data-cart-total]");
    if (total) total.textContent = money(cart.total_price);
    setCount(cart.item_count);
  }

  function getCart() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  function add(id, qty) {
    return fetch(R.cart_add, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function () { return getCart(); }).then(function () { open(); });
  }

  function change(key, qty) {
    return fetch(R.cart_change, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  // ---- delegated events ----
  document.addEventListener("click", function (e) {
    var t = e.target;

    var addBtn = t.closest("[data-add]");
    if (addBtn && addBtn.getAttribute("data-variant-id")) {
      e.preventDefault();
      add(addBtn.getAttribute("data-variant-id"), 1);
      return;
    }
    if (t.closest("[data-cart-open]")) { e.preventDefault(); getCart(); open(); return; }
    if (t.closest("[data-cart-close]")) { e.preventDefault(); close(); return; }
    if (t.closest("[data-cart-checkout]")) { e.preventDefault(); window.location.href = "/checkout"; return; }

    var line = t.closest(".gu-line");
    if (line) {
      var key = line.getAttribute("data-key");
      var qtyEl = line.querySelector(".gu-qtyrow span");
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (t.closest("[data-inc]")) { change(key, qty + 1); return; }
      if (t.closest("[data-dec]")) { change(key, Math.max(0, qty - 1)); return; }
      if (t.closest("[data-rm]")) { change(key, 0); return; }
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") close();
  });

  // initial count from Liquid
  if (typeof window.GUFFEE_CART_COUNT === "number") setCount(window.GUFFEE_CART_COUNT);
})();
